import { render } from "./melody.vue?vue&type=template&id=512c0d2a"
import script from "./melody.vue?vue&type=script&lang=js"
export * from "./melody.vue?vue&type=script&lang=js"

import "./melody.vue?vue&type=style&index=0&id=512c0d2a&lang=less&scope=true"

import exportComponent from "/root/workspace/youyi_1_tob-teacher-fe_Ff2X/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__